import { twitchService } from '../lib/twitch';

export async function handleAuthCallback(): Promise<void> {
  // Get code from either query parameter or path
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const error = urlParams.get('error');
  const errorDescription = urlParams.get('error_description');

  // Handle errors from Twitch
  if (error) {
    console.error('Twitch auth error:', errorDescription);
    window.location.href = '/';
    return;
  }

  // Validate code
  if (!code) {
    console.error('No authorization code provided');
    window.location.href = '/';
    return;
  }

  try {
    // Process the auth callback
    await twitchService.handleCallback(code);
    
    // Clean up URL and reload to show main app
    window.history.replaceState({}, '', '/');
    window.location.reload();
  } catch (error) {
    console.error('Failed to handle auth callback:', error);
    window.location.href = '/';
  }
}
